/**
 * VideoGreet invitation loaded inside its own iframe
 */

import videojs from 'video.js';
import videoGreetInvitationTemplate from '../templates/invitations/videoGreet/videoGreet.ejs';
import VideoGreetMessageHandler from './VideoGreetMessageHandler';
import QuestionTypeRendererExtentions from '../questiontypes/QuestionTypeRendererExtension';
import { BaseWidget } from '../core/BaseWidget';
import WidgetTypes from '../core/enums/WidgetTypes';
import WidgetView from '../core/WidgetView';
import TempCache from '../core/enums/TempCache';
import SourceType from '../core/enums/SourceTypes';
import BrandingWidget from '../core/enums/BrandingWidget';
import ParticipantIds from '../core/enums/ParticipantIds';
import GlobalVariables from '../core/GlobalVariables';
import cleanInvalidHtml from '../core/hooks/cleanInvalidHtml';
import ChatMode from '../core/hooks/ChatMode';
import PipedMessageHandler from '../core/hooks/PipedMessageHandler';
import ADACompliant from '../core/hooks/ADACompliant';
import {
    Position,
    PreChatMessageAnimation,
    PreChatMessageType,
    ScriptVisitorResponseStatus,
    ScriptsQuestionType
} from '../core/enums/Enum';
import parseTemplate from '../core/hooks/parseTemplate';
import Branding from '../core/hooks/Branding';
import getStyle from '../core/hooks/getStyle';
import Browser from '../core/hooks/Browser';
import removeMultipleCSSClasses from '../core/hooks/removeMultipleCSSClasses';
import encodeHTML from '../core/hooks/encodeHTML';
import decodeHTML from '../core/hooks/decodeHTML';
import removeTextFollowedByColon from '../core/hooks/removeTextFollowedByColon';
import stringify from '../core/hooks/stringify';
import addOptionProperty from '../core/hooks/addOptionProperty';
import setPrechatStyles from '../core/hooks/setPrechatStyles';
import RunAsSoonAs from '../core/hooks/RunAsSoonAs';
import Cookies from '../core/hooks/Cookies';
import ChatEvents from '../core/hooks/ChatEvents';
import WidgetStates from '../core/hooks/WidgetStates';
import getCookieValue from '../core/hooks/getCookieValue';
import getStorageAPIValue from '../core/hooks/getStorageAPIValue';
import localStorageAPIGet from '../core/hooks/localStorageAPIGet';
import storageAPIExists from '../core/hooks/storageAPIExists';
import hideElement from '../core/hooks/hideElement';
import removeClass from '../core/hooks/removeClass';
import addClass from '../core/hooks/addClass';
import localstorageAPIExists from '../core/hooks/localstorageAPIExists';
import logIt from '../../logIt';
import getStyleForIframe from '../core/hooks/getStyleForIframe';
import AgentImageHandler from '../core/hooks/AgentImageHandler';
import SwitchLanguage from '../core/hooks/SwitchLanguage';
import debounce from '../core/hooks/debounce';

export default class VideoGreetInvitation extends BaseWidget {
    constructor(options) {
        super(Object.assign(options, { styleName: 'videogreet' }));
        if (!options.videoGreetEnabled) {
            logIt('▶ Video Greet:: is disabled');
            return;
        }
        const me = this;
        me.windowHeight = window.innerHeight;

        me.templateRenderer = null;
        if (!me.options) {
            me.options = options;
        }
        me.initElements();
        if (me.options.videoGreet.chatbotGreetingMessages) {
            const script = structuredClone(me.options.videoGreet.chatbotGreetingMessages[0]);
            me.options.videoGreet.chatbotGreetingMessages[0].agentScript = script;
            delete me.options.videoGreet.chatbotGreetingMessages[0].agentScript.agentScript; // remove circular properties
            me.options.videoGreet.chatbotGreetingMessages[0].agentScript.options = JSON.stringify(me.options.videoGreet.chatbotGreetingMessages[0].agentScript.options)
            me.options.videoGreet.videoGreetMessages = me.options.videoGreet.chatbotGreetingMessages;
        }
        me.pipeMessageHandler = new PipedMessageHandler();
        me.DEFAULT_PRECHAT_CONFIG = {
            general: { template: 'Simple Style' },
            outerObject: {
                hideOuterObject: false,
                showImage: false,
                backgroundImage: '',
                background1Color: '#5FADD1',
                background2Color: '#5FADD1',
                borderColor: '#FFFFFF',
                borderWidth: '0px',
                borderRadius: '60px',
                padding: '20px 20px 20px 20px'
            },
            innerObject: {
                hideInnerObject: false,
                showImage: true,
                defaultImage: 'chat-icon-simple.png',
                backgroundImage: '',
                background1Color: '',
                background2Color: '',
                borderColor: '#FFFFFF',
                borderWidth: '0px',
                borderRadius: '0px',
                padding: '5px 5px 5px 5px'
            },
            messagePopup: {
                font: {
                    italic: false,
                    bold: false,
                    underline: false,
                    family: 'inherit',
                    size: '18px',
                    color: '#202024'
                },
                backgroundColor: '#feffe0',
                padding: '11.2px 11.2px 11.2px 11.2px',
                borderColor: '#e5e6c8',
                closeIcon: '/contents/themes/skinnable/invitation/close.png',
                closeIconSize: { width: '12px', height: '12px' },
                shadowDepth: '0px',
                borderRadius: '6px',
                borderWidth: '1px'
            },
            messageCounter: {
                font: {
                    italic: false,
                    bold: false,
                    underline: false,
                    family: 'inherit',
                    size: '10px',
                    color: '#FFFFFF'
                },
                backgroundColor: '#823710',
                counterTop: '7px',
                counterRight: '3px'
            }
        };
        const TemplateRenderer = function () {
            const self = this;
            self.hideMessagePopup = function () {
                // me.DOM.getElementById('apexchat_prechat_message_popup').style.display = 'none';
                removeMultipleCSSClasses(
                    me.DOM.getElementById('apexchat_prechat_message_popup'),
                    'prechat_zoom_in_animation_left prechat_zoom_in_animation_right'
                );
                removeMultipleCSSClasses(
                    me.DOM.getElementById('apexchat_prechat_typing_div'),
                    'prechat_zoom_in_animation_left prechat_zoom_in_animation_right'
                );
                const roundedMessagePopup = me
                    .$(me.DOM.getElementById('apexchat_prechat_message_popup_container'))
                    .find('.apexchat_prechat_message_bubble');
                if (roundedMessagePopup.length > 0) {
                    hideElement(roundedMessagePopup[roundedMessagePopup.length - 1]);
                } else {
                    addClass(
                        me.DOM.getElementById('apexchat_prechat_message_popup'),
                        'apexchat_prechat_show_message_fade_out'
                    );
                }
                // resize iframe
                // me.postMessage({ event: 'prechat-size', data: { width: me.iconWidth, height: me.iconHeight } });
            };
            self.heightPosition = 20;
            self.widgetWidth = 295;
            self.renderOnLeftPosition = function () {
                me.$('#apexchat_video_greet_invitation_frame').addClass(
                    'apexchat_video_greet_iframe_left'
                );
                addClass(
                    me.DOM.getElementById('apexchat_video_greet_invitation_max'),
                    'video_greet_invitation_left'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup'),
                    'apexchat_prechat_tri_left apexchat_prechat_left_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_container'),
                    'apexchat_prechat_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_bg'),
                    'apexchat_prechat_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_close_message_popup'),
                    'apexchat_prechat_x_right'
                );
                // Mobile responsive
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup'),
                    'apexchat_prechat_talk_bubbleMsg_left'
                );
            };
            self.renderOnRightPosition = function () {
                me.$('#apexchat_video_greet_invitation_frame').addClass(
                    'apexchat_video_greet_iframe_right'
                );
                me.$('#apexchat_video_greet_invitation_frame').css('float', 'right');
                addClass(
                    me.DOM.getElementById('apexchat_video_greet_invitation_max'),
                    'video_greet_invitation_right'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup'),
                    'apexchat_prechat_tri_right apexchat_prechat_right_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_bg'),
                    'apexchat_prechat_right'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_container'),
                    'apexchat_prechat_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_bg'),
                    'apexchat_prechat_bottom'
                );
                addClass(
                    me.DOM.getElementById('apexchat_prechat_close_message_popup'),
                    'apexchat_prechat_x_left'
                );
                // Mobile responsive
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup'),
                    'apexchat_prechat_talk_bubbleMsg_right'
                );
            };
            self.showOnlineAgentTag = function () {
                const agentName = me.DOM.getElementsByClassName('online-agent-tag');
                agentName[0].innerHTML = me.options.preChat.preChatAgentStatusText;
                // agentName[0].style.display = 'block';
                // hide online tag and glow invitation aftr 45 seconds
                setTimeout(() => {
                    // hide tag
                    // me.DOM.getElementsByClassName('online-agent-tag')[0].style.display = 'none';
                    addClass(
                        me.DOM.getElementById('apexchat_prechat_chat_icon'),
                        'glow_pre_chat_icon'
                    );
                }, 45000);
            };
            self.popupUI = function (isPreChatRoundedTheme) {
                const _render = function (message) {
                    if (!message.message && message.text) {
                        message.message = message.text;
                    }
                    me.DOM.getElementById('apexchat_prechat_message').innerHTML = message.message;
                };
                const _clearContent = function () {
                    me.DOM.getElementById('apexchat_prechat_message').innerHTML = '';
                };
                const _doNothing = function () {
                    // do nothing..
                };
                const _questionTypeUIConfiguration = function (questionType) {
                    me.setAllowBackgroundClick(questionType);
                    me.$('.apexchat_question_type_close_button', me.DOM).attr(
                        'style',
                        'display:none !important'
                    );
                    me.$('#apexchat_click_instruction', me.DOM).attr(
                        'style',
                        'display: none !important'
                    );
                    me.$('#apexchat_participant_display_name', me.DOM).attr(
                        'style',
                        'display: none !important'
                    );
                    me.$('#apexchat_participant_display_col', me.DOM).attr(
                        'style',
                        'display: none !important'
                    );
                };
                return {
                    render: _render,
                    clear: _clearContent,
                    setMessageTemplate: _doNothing,
                    questionTypeUIConfiguration: _questionTypeUIConfiguration
                };
            };
        };

        const RoundedTemplateRenderer = function (renderer, heightPosition) {
            const self = this;
            self.hideMessagePopup = function () {
                self.renderer.hideMessagePopup();
            };
            self.heightPosition = heightPosition;
            self.renderer = renderer;
            self.widgetWidth = 98;
            self.renderOnLeftPosition = function () {
                renderer.renderOnLeftPosition();
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup_container'),
                    'apexchat_prechat_rounded_theme_left'
                );
                addClass(me.DOM.getElementById('apexchat_prechat_typing_div'), 'talk_bubble_left');
                addClass(
                    me.DOM.getElementById('apexchat_prechat_main_container'),
                    'apexchat_prechat_left'
                );
                removeClass(
                    me.DOM.getElementById('apexchat_prechat_typing_div'),
                    'talk_bubble_right'
                );
            };
            self.renderOnRightPosition = function () {
                renderer.renderOnRightPosition();
                addClass(
                    me.DOM.getElementById('apexchat_prechat_message_popup_container'),
                    'apexchat_prechat_rounded_theme_right'
                );
                addClass(me.DOM.getElementById('apexchat_prechat_typing_div'), 'talk_bubble_right');
                removeClass(
                    me.DOM.getElementById('apexchat_prechat_typing_div'),
                    'talk_bubble_left'
                );
            };
            self.popupUI = function (isPreChatRoundedTheme) {
                const container = me.$('#apexchat_prechat_message', me.DOM);
                const setMessageTemplate = function () {
                    if (!isPreChatRoundedTheme) {
                        return;
                    }
                    if (!ApexChat.preChatMsgTemplate) {
                        const message = document.createTextNode('##message##'); // Create a text node
                        me.$('#apexchat_prechat_message', me.DOM).html(message);

                        const participants = ApexChat.localStorageAPI.Get(
                            'livechat_chat_participants'
                        );
                        let participantInfo = JSON.parse(participants || '{}');
                        participantInfo = participantInfo[participantInfo.length - 1];

                        // me.generateVideoGreet()
                        // if participants found then we need to update the image and agent name of the next pre-chat pop-up message
                        if (
                            participants &&
                            participantInfo &&
                            participantInfo.userId !== ParticipantIds.visitor
                        ) {
                            // Dont run for visitor case

                            if (participantInfo.handlerImageUrl) {
                                me.$(
                                    '.agent_image_prechat_rounded_theme .apexchat_prechat_chat_icon',
                                    me.DOM
                                ).css(
                                    'background-image',
                                    `url(${participantInfo.handlerImageUrl})`
                                );
                            }
                            me.$('.agent_name_prechat_rounded_theme', me.DOM).html(
                                participantInfo.displayName
                            );
                        } else {
                            me.$('.agent_name_prechat_rounded_theme', me.DOM).html(
                                me.options.agentName
                            );
                        }
                        ApexChat.preChatMsgTemplate = me
                            .$('<div>')
                            .append(me.$('#apexchat_prechat_message_popup', me.DOM).clone())
                            .html();
                        me.$('#apexchat_prechat_message_popup_container', me.DOM).addClass(
                            'apexchat_prechat_default_animation'
                        );
                        ApexChat.sessionAPI.Store(
                            'livechat_prechat_msg_template',
                            ApexChat.preChatMsgTemplate
                        );
                        me.messenger.setMessageTemplate(ApexChat.preChatMsgTemplate);
                    }
                };
                const setTabIndex = function () {
                    container.attr('tabindex', 0);
                };
                const removeTabIndex = function () {
                    container.attr('tabindex', -1);
                };
                const push = function (message) {
                    // once we showing the button then we have to hide again to do not
                    // show for Questiontypes
                    me.$('#apexchat_greet_video_start_trigger', me.DOM).hide();
                    if (!isPreChatRoundedTheme) {
                        return;
                    }
                    if (!message.message && message.text) {
                        message.message = message.text;
                    }
                    message.message = decodeHTML(
                        cleanInvalidHtml(removeTextFollowedByColon(message.message))
                    );
                    // on this switch we will take decision.
                    switch (me.options.preChatMessageAnimation) {
                        case PreChatMessageAnimation.Default:
                            renderDefault(message);
                            break;
                        case PreChatMessageAnimation.Stacking:
                        case PreChatMessageAnimation.MobileStacking:
                            renderStacking(message);
                            break;
                        default:
                            break;
                    }
                    // check chatMsg variable is exists and ApexChat.preChatElement is not undefined livechat_participant_display_text
                    if (message.questionType == ScriptsQuestionType.None) {
                        setTabIndex();
                    } else {
                        removeTabIndex();
                    }
                };

                let renderDefault = function (message) {
                    if (!message.dontAppendExisitngContent) {
                        if (message.questionType !== ScriptsQuestionType.FullText) {
                            me.$('#apexchat_prechat_message', me.DOM).html(message.message);
                        }
                        if (message && message.messageType !== PreChatMessageType.plain_Text) {
                            me.$('#apexchat_greet_video_start_trigger', me.DOM).hide();
                        }
                        else {
                            me.$('#apexchat_greet_video_start_trigger', me.DOM).show();
                        }
                    } else {
                        me.$('#apexchat_prechat_message', me.DOM).html('');
                    }
                    // we are showing with opacity 0; because we cant calculate dynamic height differences If element is Hidden,
                    // Initially, we were adding CSS Class for making Opacity 0 & 1 but adding and removing class was making a jerk we needed the animation effect between 0 to 1, in decimal manner like 0.1, 0.2, 0.3... to 0.9, 1
                    me.$('#apexchat_prechat_message_popup', me.DOM).show().css({ opacity: 0 });
                    // we need this timeout as DOM takes time to render, without timeout.
                    // ApexChat.getStyle giving wrong values without timeout.
                    const ele = me.$('#apexchat_prechat_message_popup', me.DOM);

                    // padding and shadow
                    const padding = 15; // increased 15px// CHAT-5979 [V3] Pre - chat with default animation is cutting of shadow on top.
                    // Initially, we were adding CSS Class for making Opacity 0 & 1 but adding and removing class was making a jerk we needed the animation effect between 0 to 1, in decimal manner like 0.1, 0.2, 0.3... to 0.9, 1
                    ele.css({ opacity: 0 });
                    ele.hide().show().animate({ opacity: 1, top: padding }, 300);
                };
                const renderStacking = function (message) {
                    me.messenger.push(message);
                };
                const doNothing = function () { };
                const questionTypeUIConfiguration = function (questionType) {
                    me.setAllowBackgroundClick(questionType);
                    me.$('.apexchat_question_type_close_button', me.DOM).attr(
                        'style',
                        'display:none !important'
                    );
                    me.$(
                        '.apexchat_participant_display_text#apexchat_participant_display_name',
                        me.DOM
                    ).attr('style', 'display: none !important');
                    me.$(
                        '.apexchat_participant_display_text#apexchat_participant_display_col',
                        me.DOM
                    ).attr('style', 'display: none !important');
                };
                return {
                    setMessageTemplate,
                    render: push,
                    clear: doNothing,
                    questionTypeUIConfiguration
                };
            };
        };

        let renderer = new TemplateRenderer();
        me.options.isPreChatRoundedTheme = true;
        renderer = new RoundedTemplateRenderer(renderer, 130);
        me.templateRenderer = renderer;

        if (options.chatMode == ChatMode.Windowed) {
            this.mode = WidgetTypes.Windowed;
        } else if (options.chatMode == ChatMode.DOM) {
            this.mode = WidgetTypes.DOM;
        }
        this.lastMessageStoreName = 'livechat_prechat_lastmessage';
        this.messageCounterStoreName = 'livechat_prechat_messagecounter';

        if (me.isPageRefreshed() || !me.options.videoGreet) {
            me.ready();
        } else {
            setTimeout(() => {
                me.ready();
            }, 50);
        }
        this.messageArray = [];
    }

    ready() {
        const me = this;
        super.ready();
        me.create();
        /* messenger is taking instance of VideoGreetMessageHandler with few important arguments
         * */
        if (me.options.videoGreet) {
            me.messenger = new VideoGreetMessageHandler( // encapsulated message handler for VideoGreet
                Object.assign(me.options, {
                    context: me.DOM,
                    videoGreetTemplate: me.options.videoGreet.videoGreetInvitationWidgetTemplate,
                    videoGreetModel: me.options.videoGreet
                })
            );
        }
    }

    create() {
        super.create();
        const me = this;

        me.view = new WidgetView({
            dom: this.DOM,
            identifier: WidgetTypes.VideoGreetInvitation,
            templates: [
                {
                    key: WidgetStates.ShownMaximized,
                    tpl: videoGreetInvitationTemplate(me.options.videoGreet), // // me.options.videoGreet.videoGreetInvitationWidgetTemplate,
                    model: me.options.videoGreet,
                    async afterRender(tpl) {
                        me.messagesContainer = me.DOM.getElementById('apexchat_prechat_message');
                        const handleQuestionTypeResponse = async function (res) {
                            await me.handleQuestionType(res.res || res);
                        };
                        me.postMessage({ event: 'videogreet-init', data: {} });
                        // message rendering
                        if (!me.QTRendererExt && me.options.videoGreet) {
                            me.QTRendererExt = new QuestionTypeRendererExtentions();
                            await me.QTRendererExt.initComponent(
                                Object.assign(me.options.videoGreet, {
                                    isUpdateSupported: false,
                                    context: me.DOM,
                                    messagesContainer: me.DOM.getElementById(
                                        'apexchat_prechat_message'
                                    ),
                                    responseCallback: handleQuestionTypeResponse,
                                    enableFullTextLogic: true,
                                    widgetType: WidgetTypes.VideoGreetInvitation,
                                    countryCode: me.options.countryCode
                                })
                            );
                        }
                        const isVideoGreetMaximized =
                            me.state.getStateValue(WidgetTypes.VideoGreetInvitation) ===
                            WidgetStates.ShownMaximized;
                        // JIRA_7493 & 7477 ChatId Null issue
                        me.options.chatId = me.options.chatId || me.getChatId();
                        if (
                            me.isChatActive() &&
                            me.isPageRefreshed() &&
                            isVideoGreetMaximized &&
                            me.options.chatId
                        ) {
                            RunAsSoonAs(
                                () => {
                                    // Creating ChatRoom object for sending the Video Greet Agent Script's replies to dashboard via websync.
                                    me.videoGreetRoom = new ApexChat.ChatRoomV3(
                                        Object.assign(me.options, me.options.model)
                                    );

                                    // We don't need to subscribe this channel if exit-popup is in maximize state and user refresh the page,
                                    // if we do that the last message of the user will show as a duplicate message on exit-popup
                                    me.videoGreetRoom.subscribeToChatChannel(me.options.chatId);
                                },
                                () => ApexChat.ChatRoomV3 != undefined
                            );
                        }
                        // pasre/apply pre chat theme setting
                        if (me.options.videoGreet) {
                            const prechatSkin = JSON.parse(me.options.preChat?.preChatThemeSetting ?? "{}");

                            me.skin = me.DEFAULT_PRECHAT_CONFIG;
                            if (prechatSkin.messagePopup) {
                                me.skin.messagePopup = prechatSkin.messagePopup;
                            }
                            // if the user name has a space then we need to enclose the image URL in single quote.
                            me.skin.handlerImageUrl = `'${AgentImageHandler(me.options.handlerImageUrl)}'`;
                            const rdThemeSettings =
                                me.options && me.options.rdThemeSettings
                                    ? ApexChat.TryParse(me.options.rdThemeSettings)
                                    : null;
                            let skinJson = {
                                container: '',
                                preChat: me.skin
                            };

                            skinJson.rdThemeSettings = rdThemeSettings;
                            /* Branding - PreChat */
                            const brandingInfo = skinJson.rdThemeSettings.branding || {};
                            if (brandingInfo.brandingIsEnabled && brandingInfo.brandColorCode) {
                                skinJson.global = { branding: brandingInfo };
                                skinJson = new Branding()
                                    .init({
                                        widget: BrandingWidget.RD_PreChat,
                                        brandConfig: skinJson
                                    })
                                    .getBrandedConfig();
                            }
                            // add css
                            // const bindingDynamicStyles = parseTemplate(
                            //     me.options.videoGreet.videoGreetCSS,
                            //     skinJson
                            // );
                            // const bindingDynamicPrechatStyles = parseTemplate(
                            //     me.options.videoGreet.preChatCSS,
                            //     skinJson
                            // );
                            setPrechatStyles(me.DOM, skinJson);
                            // addStyleTextInIframe(
                            //     bindingDynamicStyles,
                            //     'apexchat_video_greet_css',
                            //     undefined,
                            //     me.DOM
                            // );
                            // addStyleTextInIframe(
                            //     bindingDynamicPrechatStyles,
                            //     'apexchat_pre_chat_css',
                            //     undefined,
                            //     me.DOM
                            // );

                            // set UI configuration
                            // Utils.fontsLoaded({
                            //     fontName: 'Avenir',
                            //     context: me.DOM,
                            //     window: me.iFrameWindow,
                            //     onSuccess() {
                            //         me.UIConfiguration();
                            //     }
                            // });
                            setTimeout(() => {
                                me.UIConfiguration();
                            }, 0);
                            hideElement(me.DOM.getElementById('apexchat_prechat_message_popup')); // Hide the initial popup

                            // CHAT_8288 - Remove white background for all image extension and added for .png only
                            if (me.DOM && me.DOM.getElementById('apexchat_prechat_chat_icon')) {
                                const backgroundImage = getStyle(
                                    me.DOM.getElementById('apexchat_prechat_chat_icon'),
                                    'background-image'
                                );
                                if (backgroundImage && backgroundImage.indexOf('.png') === -1) {
                                    me.$('#apexchat_prechat_main_bg', me.DOM).addClass(
                                        'apexchat_css_background_transparent'
                                    );
                                }
                            }
                        }

                        const options = {
                            context: me.options.context,
                            options: {
                                ...me.options,
                                model: {
                                    ...tpl.model,
                                    supportedLanguagesList: me.options.supportedLanguagesList,
                                },
                                elements: {
                                    ...this.elements,
                                    language_bottomSheet: '#livechat_video_greet_languages',
                                    actionMenuLanguageSwitcher: `#${me.options.videoGreetLanguageDropdown}`,
                                },
                            },
                            chatModel: me.options.model || {},
                        }

                        me.switchLang = new SwitchLanguage({ ...me, ...options });
                        me.switchLang.handleLanguageChangeRequest = me.handleLanguageChange.bind(me, options);
                        const config = {
                            model: {
                                ...tpl.model,
                                ...me.options,
                            },
                            chatModel: me.options.model || {},
                            elements: {
                                ...this.elements,
                                language_bottomSheet: '#livechat_video_greet_languages',
                            },
                            context: me.options.context,
                            options: me.options,
                        }
                        me.switchLang.renderMultiLanguageDropDown(config);
                        me.handleLanguageDropdown();
                    }
                }
            ],
            initialState: WidgetStates.ShownMaximized
        });
    }

    // handle language change
    handleLanguageChange(any, config) {
        const { container, trigger, uicontroller } = config;
        const me = this;
        // binding change event to the list input
        container[0].querySelectorAll('input').forEach(input => {
            input.addEventListener('change', async function (e) {
                try {
                    const languageTrigger = me.DOM.getElementById(me.options.videoGreetLanguageDropdown);
                    languageTrigger.classList.add('apexchat_loading');
                    // Cookies.set(me.lastMessageStoreName, "{index: 0, duration: 1000}");
                    me.setLastMessageCache(0, 1000);
                    const threeLetterISOLanguageName = e.target.value ?? uicontroller.nonSMSLanguages[0].threeLetterISOLanguageName ?? 'eng'
                    let messageId = getCookieValue(TempCache.APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE) || [];       //dealing with multiple IDs
                    messageId = JSON.parse(messageId);
                    const data = await me.fetchUpdatedLanguage(threeLetterISOLanguageName, messageId);
                    if (Array.isArray(me.messageArray)) {
                        me.messageArray = [];
                    }
                    if (Array.isArray(ApexChat.videoGreetMessagesDisplayed)) {
                        ApexChat.videoGreetMessagesDisplayed = []
                    }
                    me.DOM.getElementById('apexchat_prechat_message').innerHTML = '';
                    me.queueAutoMessaging(me);
                    ApexChat.localStorageAPI.Store(TempCache.LIVE_THREE_LETTER_ISO_LANG, threeLetterISOLanguageName);
                    setTimeout(() => {
                        languageTrigger.classList.remove('apexchat_loading');
                    }, 2000)
                } catch (error) {
                    console.log(error, 'handleLanguageChange error');
                }
            })
        });
    }

    async fetchUpdatedLanguage(threeLetterISOLanguageName, messageId) {
        const me = this;
        let payload = {
            companyId: ApexChat.Invitation.config.companyId,
            profileId: ApexChat.Invitation.config.profileId,
            threeLetterISOLanguageName: threeLetterISOLanguageName
        }
        let messageIds = Array.isArray(messageId)
            ? messageId
            : String(messageId)
                .split(',')
                .map(x => x.trim())
                .filter(x => x !== '')
                .map(x => Number(x));

        let query = new URLSearchParams(payload);

        // Append each messageId separately (so backend binds to long[])
        messageIds.forEach(id => query.append('messageId', id));

        const queryString = query.toString();
        const apiPath = `${env.API_URL}/api/invitations/video-greet-messages?${queryString}`;
        const response = await fetch(apiPath);
        const data = await response.json();
        TempCache.videoGreetSwitchedLanguage = threeLetterISOLanguageName;
        me.options.videoGreet.videoGreetMessages = data;
        return data
    }

    // handle language dropdown
    handleLanguageDropdown() {
        var me = this;
        const langugesDropdown = me.DOM.getElementById(me.options.videoGreetLanguageDropdown);
        const langugesList = me.DOM.getElementById(me.options.videoGreetLanguageList);

        if (!langugesDropdown || !langugesList) return;
        // Toggle the dropdown
        langugesDropdown.addEventListener('click', function () {
            langugesDropdown.classList.toggle('dropdown-open');
            langugesList.classList.toggle('show-languages');
        })
        // Add active class
        langugesList.querySelectorAll('li').forEach(item => {
            // item.querySelector('input').value;
            if (item.querySelector('input').checked) {
                item.classList.add('active');
            }

            item.addEventListener('click', function () {
                // Remove 'active' from all
                langugesList.querySelectorAll('li').forEach(li => li.classList.remove('active'));

                // Close the dropdown
                setTimeout(() => {
                    langugesDropdown.classList.remove('dropdown-open');
                    langugesList.classList.remove('show-languages');
                }, 500);
                // Add to the clicked one
                this.classList.add('active');
            });
        });
    }
    initElements() {
        const me = this;
        me.options.prechatMessagesContainer = '.apexchat_prechat_videogreet_container';
        me.options.videoGreetCloseTrigger = '.apexchat_greet_video_close';
        me.options.isVideoGreetMaximized = 'apexchat_video_greet_maximized';
        me.options.videoGreetInvitationContainer = '#apexchat_invitation_container_wrapper';
        me.options.videoGreetInvitationOverlayTrigger = '#apexchat_greet_video_trigger_overlay';
        me.options.videoGreetSeekbar = '#apexchat_greet_video_seekbar';
        me.options.videoGreetPlayTrigger = '#apexchat_greet_video_play';
        me.options.videoGreetPlayPauseIcon = '#play_pause_icon';
        me.options.togglePlayerClassess =
            'greet_video_invitation_container_minimized greet_video_invitation_container_maximized';
        me.options.vimeoAPIURL = 'https://embed.cloudflarestream.com/embed/sdk.latest.js';
        me.options.playerElementId = 'greet_video_player';
        me.options.vimeoScriptID = 'vimeo_js';
        me.options.videoGreetLoader = '#video_greet_loader';
        me.options.videoGreetControls = '#apexchat_greet_video_controls';
        me.options.videoGreetLanguageDropdown = 'apexchat_greet_video_language_dropdown';
        me.options.videoGreetLanguageList = 'livechat_video_greet_languages';
        ApexChat.WidgetMinimizedWidth = 234;
        ApexChat.WidgetMinimizedHeight = 451;
        ApexChat.WidgetMaximizedWidth = me.options.videoGreet.persistVideoRatioForWidget
            ? 366
            : 380;
        ApexChat.WidgetMaximizedHeight = me.options.videoGreet.persistVideoRatioForWidget
            ? 650
            : 508;

        me.options.videoPlayerConfig = {
            id: me.options.videoGreet.videoGreetURL,
            width: 300,
            loop: true,
            controls: false,
            byline: false,
            title: false,
            muted: true,
            autoplay: true,
            background: true
        };
        me.options.videoGreetMuteTrigger = '#apexchat_greet_video_mute';
        me.options.videoGreetTooltip = '.video_greet_text';
        me.options.videoGreetTooltipText = '.video_greet_text_thought';
    }

    postVideoGreetMessages(res) {
        const me = this;
        // We need to prevent multiple posting of same ChatLogID, created an array and saving the chatlogId
        me.postedVideoGreetMessagesArray = me.postedVideoGreetMessagesArray || [];
        // if the chatlogId is already being posted, preventing it to repost which was making text appear twice in dashboard
        if (
            res.chatLogId &&
            me.postedVideoGreetMessagesArray.indexOf(res.chatLogId) !== -1 &&
            !(res.questionType != ScriptsQuestionType.Text)
        ) {
            return false;
        }
        // saving chatlogId is array
        // check checklogid exists or not
        if (res.chatLogId && me.postedVideoGreetMessagesArray.indexOf(res.chatLogId) !== -1) {
            me.postedVideoGreetMessagesArray.push(res.chatLogId);
        }
        me.postMessage({
            event: WidgetTypes.VideoGreetInvitation + WidgetStates.MessageSent,
            data: res
        });
        const domRendered = ApexChat.PubSub.allSubscriptions()[WidgetTypes.DOMUIController]; // DOM has not opened?
        // We only need to send the VideoGreet Agent Script's replies to dashboard via 'videoGreetRoom' object until DOM appeared.
        me.startChatFromVideoGreet(); /* <--CHAT-6961 - Open Chat window, no need to continue mapping on VideoGreet */
        if (!domRendered) {
            me.videoGreetRoom.setWebSyncClient();
            me.videoGreetRoom.publishQuestionTypeResponse(res);
            // Set the visitor selection of question type
            res.visitorSelectedOptions = res.answers;
            res.questionType = me.QTRendererExt.questionTypeRenderer.renderer.model.questionType;
            res.questionTypeDisplayListForVisitor =
                me.QTRendererExt.questionTypeRenderer.renderer.model.questionTypeDisplayListForVisitor;
            res.id = res.chatLogId;

            res.visitorScriptAnswer = res.answers;
            res.visitorResponseStatus = res.isSkipped
                ? ScriptVisitorResponseStatus.Skipped
                : ScriptVisitorResponseStatus.Answered;
            me.QTRendererExt.questionTypeRenderer.setVisitorSelection(res);
            me.videoGreetRoom.sendMessage({
                chatMsg: res.msgText,
                questionTypeChatLogIdToBeUpdated: res.questionTypeChatLogIdToBeUpdated
            });
        }
    }

    /**
     * Handling all question type message like, true, false, MC, ATA etc (Click and selection) events
     * This also handling a mapped question for example user select a yes button in true false question type and the
     * yes button is mapped with other question, it will call the api to get the next mapped question.
     * @param {res} message response
     */
    async handleQuestionType(res) {
        const me = this;
        const url = `${GlobalVariables.ApexChatBaseUrl}api/prechat/messages`;
        const message = me.getLastMessageCache();
        // commenting below code because we dont need to decrease counter immediately when question answered we first need to check
        // if map question associated with questiontype then mapped question must be answered before decreasing counter.
        if (!me.isLastMessageMappedWithNextQuestion && me.isChatActive()) {
            // The counter will not decrease when it was already decreased by it's parent question type
            // Decrease the message counter when user response on any question type
            // for example click on Yes or No button then we decrease the counter
        }
        // This variable (isLastMessageMappedWithNextQuestion) is become true when the next question exist for this response
        // At user response time we do not know that either this question is mapped or not we only
        me.templateRenderer.hideMessagePopup();
        me.isLastMessageMappedWithNextQuestion = false;
        window.clearTimeout(me.messageTimeout);
        if (!me.isVideoGreetMessage) {
            me.postVideoGreetMessages(res);
            return;
        }
        const log = {};
        log.visitorId = me.options.visitorId;
        log.companyId = me.options.companyId;
        log.language = me.options.language;
        log.id = me.videoGreetMessageId;
        log.scriptAnswerId = me.agentScriptAnswerId;
        log.sourceType = SourceType.VideoGreet;
        // In case of FULL TEXT PreChat, We dont send the response to server, It renders multiple times, We save it and send it via websync object.
        if (res.questionType === ScriptsQuestionType.FullText) {
            log.visitorResponseStatus = ScriptVisitorResponseStatus.Skipped;
            ApexChat.FullTextVisitorResponse = res.answers;
        } else {
            log.visitorScriptAnswer = res.answers;
            log.visitorResponseStatus = res.isSkipped
                ? ScriptVisitorResponseStatus.Skipped
                : ScriptVisitorResponseStatus.Answered;
        }

        // checking if visitor respond any script question than do not display EP
        if (!res.isSkipped) {
            ApexChat.storageAPI.StoreTemp('livechat_prechat_started', true);
            window.clearTimeout(me.prechatStartedTimeout);
        }

        let isLastPreChatMessage = true;
        ApexChat.shouldContinueMapping = true;
        const encodedLog = encodeHTML(JSON.stringify(log));

        /* #ScriptBot-CHAT-6961:TODO - START - commenting the below code for ScriptBot Flow, When the feature will be final, will remove all commented TODOs */
        if (!ApexChat.ContactInfo) {
            const response = await fetch(url, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                method: 'POST',
                body: encodedLog
            });
            const result = await response.json();
            if (!response.ok) {
                // throw new Error("Network response was not ok");
                logIt('Error: Network response was not ok');
            }
        }
        /* #ScriptBot-CHAT-6961:TODO - END - */
        if (!ApexChat.ContactInfo) {
            const timerToStartChat = setInterval(() => {
                if (isLastPreChatMessage && !res.isSkipped) {
                    // JIRA_4308 - closing prechat triggers the chat (Fixed by adding this isSkipped Flag)
                    isLastPreChatMessage = false;
                    // point 1 in case of qt
                    me.startChatFromVideoGreet();
                } else {
                    clearInterval(timerToStartChat);
                }
            }, 500);
        }
        // In case of TEXT PreChat, We save it and send it via websync object.
        if (res.questionType === ScriptsQuestionType.Text && res.contactInfo) {
            ApexChat.localStorageAPI.Store(TempCache.LIVE_CONTACTINFO, res.contactInfo);
            ApexChat.ContactInfo = res.contactInfo;
        }
    }

    startChatFromVideoGreet(e, config) {
        const me = this;
        me.$('#apexchat_invitation_container_wrapper', me.DOM).addClass(
            'greet_video_invitation_container_start_chat'
        );
        setTimeout(() => {
            // is there a srcElement passed and it has a data attribute named shouldStartChat with value = false? return.
            if (
                (config && !config.srcElement) ||
                (config && config.srcElement && !me.$(config.srcElement).data('shouldStartChat'))
            ) {
                return false;
            }
            // me.resetVideoGreetVideo();
            // me.postMessage({ event: WidgetTypes.VideoGreetInvitation + WidgetStates.Clicked, data: {} });
            // me.initiatedBy = 'PreChat';
            me.state.changeState({
                toState: WidgetStates.Clicked,
                value: { initiatedBy: 'VideoGreet' }
            });
            me.handlePrechatVisiblity();
            if (me.isWindowedStarted() || me.options.chatMode == ChatMode.Windowed) {
                me.options.chatInitiatedBy = 'PreChat';
                me.startWindowedChat(
                    Object.assign(me.options, {
                        shouldContinueMapping: ApexChat.shouldContinueMapping,
                        FullTextVisitorResponse: ApexChat.FullTextVisitorResponse
                    })
                ); // pass parameter as a querystring
            }
        }, 100);
    }

    UIConfiguration() {
        const me = this;
        const position = me.options.videoGreet.videoGreetPosition;
        // get width/height of prechat object without popup message
        const el = me.DOM.getElementById('apexchat_prechat_chat_icon');
        if (el) {
            me.iconWidth = el.offsetWidth + 30;
            me.iconHeight = el.offsetHeight + (me.skin.outerObject.hideOuterObject ? 0 : 20);
            ApexChat.PreChatIconDimensions = {
                Width: me.iconWidth,
                Height: me.iconHeight
            };
        }

        me.templateRenderer.hideMessagePopup();
        // apply css class to prechat object base on position
        me.applyCssClass(position);

        const isMaximized = me.isVideoGreetStateMaximized();
        // notify iframe for resize
        me.postMessage({
            event: 'videogreet-size',
            data: {
                isPreChatRoundedTheme: me.options.isPreChatRoundedTheme,
                width: isMaximized ? ApexChat.WidgetMaximizedWidth : me.iconWidth,
                height: isMaximized ? ApexChat.WidgetMaximizedHeight : me.iconHeight
            }
        });
        if (!me.isChatInProgress()) {
            // ref. CHAT-4589: we should stop pre-chat message popups on susequent page reloads
            // me.queueAutoMessaging();
        }

        // bind close button
        if (me.options.isMobile) {
            me.$('#apexchat_prechat_close_message_popup', me.DOM).show();
        }
        me.$(this.options.videoGreetTooltip, me.DOM)
            .children(this.options.videoGreetTooltipText)
            .on('click', () => {
                me.$(me.options.videoGreetInvitationOverlayTrigger, me.DOM).trigger('click');
            });
        me.$(me.DOM).on('click', '.apexchat_mc_ata_list', (e) => {
            me.startChatFromVideoGreet(); // click on option DOM window open
        });
        me.$(me.DOM).on('click', '.apexchat_mc_ata_list', (e) => {
            me.startChatFromVideoGreet(); // click on option DOM window open
        });
        me.$(me.DOM).on('click', '.live_chat_scheduler_bg', (e) => {
            me.startChatFromVideoGreet(); // click on option DOM window open
        });
        me.eventSubscription();
        // get icon object for start chat event binding default use inner object but if inner object is hide then use outer object
        let startChatDiv = 'apexchat_prechat_chat_icon';
        if (me.skin.innerObject.hideInnerObject) {
            startChatDiv = 'apexchat_prechat_main_bg';
        }
        this.options.containerId = startChatDiv;

        me.setClickCallToAction(startChatDiv, 'PreChat', {
            shouldContinueMapping: ApexChat.shouldContinueMapping,
            FullTextVisitorResponse: ApexChat.FullTextVisitorResponse
        }); // pass parameter to send via query string
        const domState = me.state.getStateValue(WidgetTypes.DOM);
        const isChatInActiveAndDomMinimized =
            (domState == WidgetStates.ShownMinimized || domState == WidgetStates.Closed) &&
            !me.isChatActive();
        if (isChatInActiveAndDomMinimized) {
            // when dom is minimized/closed and chat is inactive we need to show prechat widget
            me.show();
            me.initVideoGreet();
        } else if (me.getCurrentState() === WidgetStates.Hidden && me.isChatActive()) {
            me.hide();
        } else {
            // Stop to show the prechat initial messages and hide the widget when chat started already.
            if (
                domState == WidgetStates.ShownMaximized ||
                me.getCurrentState() == WidgetStates.Hidden
            ) {
                me.options.videoGreet.videoGreetMessages = [];
                me.hide();
            } else {
                me.initVideoGreet();
            }
        }
    }

    initVideoGreet() {
        const me = this;
        if (!ApexChat.Vimeo && me.options.videoGreet.videoGreetURL) {
            getStyleForIframe(
                `https://vjs.zencdn.net/8.16.1/video-js.css`,
                'apexchat_Iframe_videogreet',
                me.options.iframeId || me.options.model.iframeId || 'apexchat_browser_chatwindow_max'
            );
            const videoTemplate = `<video-js id="video-greet-pl" autoplay muted loop preload="auto">
                                <source src="${me.options.videoGreet.videoGreetURL}/manifest/video.m3u8"
                                type="application/x-mpegURL" />
                              </video-js>`;
            me.DOM.getElementById('greet_video_player').innerHTML = videoTemplate;
            const options = {
                controls: false,
                autoplay: true,
                preload: 'auto',
                fill: true,
                muted: true,
                playsinline: true
            };
            const player = me.DOM.getElementById('video-greet-pl');
            videojs(player, options).ready(function () {
                me.DOM.getElementById('apexchat_greet_video_controls').style.display = 'block';
                me.DOM.getElementById('apexchat_prechat_message_popup').style.display = 'block';
                const myPlayer = this;
                myPlayer.play();
                me.videoPlayer = this;
                me.generateVideoGreet();
            });
        }
    }

    eventSubscription() {
        const me = this;
        const hideIt = function (isMobile) {
            me.isChatStartedFromPreChat = true; // CHAT-7681 Iphone prechat double greeting Issue
            if (me.options.chatMode === ChatMode.DOM || ChatMode.Windowed || isMobile) {
                me.hide();
            } else {
                window.clearTimeout(me.messageTimeout);
            }
        };
        const chatStartedFromExitPopup = function () {
            me.hide();
            if (me.videoPlayer) {
                // check vimeo player exists then pause the video
                me.videoPlayer.pause();
            }
        };
        const chatStartedFromPrechat = function () {
            me.isChatStartedFromPreChat = true; // CHAT-7681 Iphone prechat double greeting Issue
            if (me.videoPlayer) {
                // check vimeo player exists then pause the video
                me.videoPlayer.pause();
            }
            // CHAT-6794 // need to remove the last stored mapped question because another parent question has appeared.
            ApexChat.storageAPI.Remove(TempCache.APEXCHAT_PRECHAT_MAPPED_QUESTION_COOKIE);
            // Show Windowed Widget instead DOM, when Windowed chat already started
            if (me.options.chatMode === ChatMode.DOM) {
                hideIt();
            }
        };
        const cleanUp = function () {
            // JIRA_6472 - Greeting was not appearing on reinitializing
            // summary: Removing the PreChat Message Sent helped the greeting to appear it again.
            ApexChat.storageAPI.Remove(TempCache.PreChat_Message_Sent);
        };
        const showIt = function () {
            const domState = me.state.getStateValue(WidgetTypes.DOM);
            if (domState == WidgetStates.ShownMaximized) {
                return;
            }
            me.show();
        };
        // subscribe for chat Message and typing indicator when chat mode has set to dom
        if (me.options.chatMode == ChatMode.DOM) {
            me.subscribe(WidgetTypes.DOM + WidgetStates.Closed, hideIt);
            me.subscribe(WidgetTypes.DOM + WidgetStates.ShownMinimized, hideIt);
        }
        // subscribe for start chat event from any invitation
        me.subscribe(WidgetTypes.ExitPopup + WidgetStates.ShownMaximized, chatStartedFromExitPopup);
        me.subscribe(WidgetTypes.ExitPopup + WidgetStates.Closed, () => {
            me.postMessage({
                event: 'videogreet-gif-file-loaded',
                data: {
                    imageUrl: me.options.videoGreet.animatedImageUrl
                }
            });
        });
        me.subscribe(WidgetTypes.VideoGreetInvitation + WidgetStates.Closed, () => {
            hideIt(me.options.isMobile || false);
        });
        me.subscribe(WidgetTypes.DropDown + WidgetStates.Clicked, hideIt);
        me.subscribe(WidgetTypes.Bar + WidgetStates.Clicked, hideIt);
        me.subscribe(WidgetTypes.Tab + WidgetStates.Clicked, hideIt);
        me.subscribe(
            WidgetTypes.VideoGreetInvitation + WidgetStates.Clicked,
            chatStartedFromPrechat
        );
        // When Chat Session Ends, On very next message from Visitor, an overlay mask for starting new chat appears,
        // & visitor starts the chat at this point we need to delete few cookies for PreChat.
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnSendMessageFailure, cleanUp);
    }

    applyCssClass(position) {
        // apply css classes base on pre chat position
        const me = this;
        // remove default classes
        removeClass(
            me.DOM.getElementById('apexchat_prechat_main_container'),
            'apexchat_prechat_theme_margin'
        );
        removeClass(
            me.DOM.getElementById('apexchat_prechat_message_popup'),
            'apexchat_prechat_tri_left'
        );
        removeClass(
            me.DOM.getElementById('apexchat_prechat_message_popup'),
            'apexchat_prechat_left_top'
        );
        removeClass(
            me.DOM.getElementById('apexchat_prechat_close_message_popup'),
            'apexchat_prechat_x_right'
        );
        removeClass(
            me.DOM.getElementById('apexchat_prechat_message_popup'),
            'apexchat_prechat_tri_left_theme'
        );
        addClass(
            me.DOM.getElementById('apexchat_prechat_close_message_popup'),
            'apexchat_prechat_x'
        );

        me.DOM.getElementById('apexchat_prechat_main_container').style.position = 'relative';
        me.DOM.getElementById('apexchat_rd_invitation_bg').style.position = 'fixed';
        switch (position) {
            case Position.Left:
                me.templateRenderer.renderOnLeftPosition();
                break;
            case Position.Right:
                me.templateRenderer.renderOnRightPosition();
                break;
            default:
        }
    }

    async autoMessageRendering(options) {
        const me = this;
        const { message } = options;
        const { chatMsg } = options;
        // as we are making Mock JSON for Pipe messaging, In case of Default Animation, we need to prevent the appending of content
        if (me.options.preChatMessageAnimation === PreChatMessageAnimation.Default) {
            if (message && message.messageType !== PreChatMessageType.plain_Text) {
                message.dontAppendExisitngContent = false;
            }
            if (chatMsg && chatMsg.messageType !== PreChatMessageType.plain_Text) {
                chatMsg.dontAppendExisitngContent = true;
            }
        }
        const { index } = options;
        // check message type is script message or plain message
        if (
            (index == -1 && chatMsg) ||
            (message &&
                message.messageType == PreChatMessageType.agent_Script &&
                message.agentScript)
        ) {
            const questionType = chatMsg ? chatMsg.questionType : message.questionType;
            me.messagePopupUI.render(chatMsg || message);
            me.messagePopupUI.clear();
            await me.renderScriptMessage(chatMsg || message.agentScript);
            me.messagePopupUI.questionTypeUIConfiguration(questionType);
        } else {
            // create model for message logging
            const messageLog = {};
            messageLog.visitorId = me.options.visitorId;
            messageLog.text = message.message;
            messageLog.sourceType = SourceType.VideoGreet;
            await me.logMessageOnServer(messageLog);
            // render plain text message
            me.messagePopupUI.render(message);
        }
        // check message is prechat or chat flow
        if (
            !options.isPipedMessage &&
            message &&
            message.questionType == ScriptsQuestionType.None
        ) {
            me.queueNextMessage(index + 1, message.duration * 1000);
        }
        if (options.cb) {
            options.cb();
        }
    }

    async displayMessage(index, isVideoGreetMessage, chatMsg) {
        const me = this;
        if (me.isWindowedStarted()) {
            return; // no pop message if Windowed has started
        }
        // if chat started from prechat and chatmsg is undefined and isVideoGreetMessage true appears thats means its a prechat messages appearing so we dont need it to show because chat has already been started
        // Also, on windowed mode if chat started then we dont need to show popup while windowed mode is on.
        if (!chatMsg && me.isChatStartedFromPreChat && isVideoGreetMessage) {
            return;
        }
        const preChatMsg = me.options.videoGreet.videoGreetMessages[index];
        // CHAT-7226  Next Mapped Question Logic Change
        // as option property removed from backend now we explicity add option property to our msg.options object,
        // because all QT UI depend upon that property.
        if (
            preChatMsg &&
            preChatMsg.questionType != ScriptsQuestionType.None &&
            preChatMsg.agentScript &&
            preChatMsg.agentScript.options
        ) {
            preChatMsg.agentScript.options = addOptionProperty(preChatMsg.agentScript.options);
        }
        me.messagePopupUI = me.templateRenderer.popupUI(me.options.isPreChatRoundedTheme);
        me.messagePopupUI.setMessageTemplate();
        me.isVideoGreetMessage = isVideoGreetMessage;
        me.agentScriptAnswerId = 0;
        me.allowBackgroundClick = true;
        /// Wait for the flag/setting called “re-show after” which wipes the cookies after X amount of minutes and will treat them as a new visitor
        me.prechatStartedTimeout = window.setTimeout(() => {
            ApexChat.storageAPI.StoreTemp('livechat_prechat_started', false);
        }, me.options.reShowIntervalMinutes * 60 * 1000);
        // checking message type is prechat message or chat message
        if (isVideoGreetMessage && !me.isChatStartedFromPreChat) {
            // get prechat message
            const message = me.options.videoGreet.videoGreetMessages[index];
            if (message) {
                message.message = parseTemplate(
                    removeTextFollowedByColon(message.message),
                    me.options
                );
            }
            message.text = message.text || message.message;
            const msgObject = {
                m: message.agentScript || message
            };
            if (me.pipeMessageHandler.isValidPipedMessage(msgObject)) {
                msgObject.isSplitMessage = true; // if message is piped define isSplitMessage to true
                // CHAT-7351- Split Message send as a one message on server.
                // in below logic we just send a pipe message as one message to server
                const messageLog = {};
                // create model for message logging
                messageLog.visitorId = me.options.visitorId;
                messageLog.text = removeTextFollowedByColon(msgObject.m.text);
                messageLog.scriptAnswerId = msgObject.m.id;
                messageLog.questionType = msgObject.m.questionType;
                messageLog.visitorResponseType = msgObject.m.visitorResponseType;
                messageLog.options = msgObject.m.options;
                messageLog.visitorResponseStatus = ScriptVisitorResponseStatus.UnAnswered;
                messageLog.questionTypeDisplayListForVisitor = msgObject.m.displayListForVisitor;
                messageLog.sourceType = SourceType.VideoGreet;
                await me.logMessageOnServer(messageLog); // logging message to server
                me.pipeMessageHandler.startPolling({
                    messageDisplayDuration:
                        message.duration > 100 ? message.duration : message.duration * 1000, // detecting either Its Seconds or Milliseconds
                    init() { },
                    async startPollingCallback(m) {
                        m.message = m.text;
                        await me.autoMessageRendering({
                            chatMsg: m,
                            index: -1,
                            isPipedMessage: true
                        });
                        // In Piped messages the message can be QT we need QT to not to start chat IF user clicks on their DIV HTML Element
                        const shouldStartChat = m.questionType == ScriptsQuestionType.None;
                        me.bindPopupForStartingChat({
                            popupSelector: '.apexchat_prechat_message_bubble',
                            shouldStartChat
                        });
                    },
                    lastPollingCallback(args) {
                        const { m } = args;
                        m.message = m.text;
                        me.autoMessageRendering({
                            chatMsg: m,
                            index: -1,
                            isPipedMessage: true,
                            cb: args.cb
                        });
                        // In Piped messages the last message can be QT we need QT to not to start chat IF user clicks on their DIV HTML Element
                        const shouldStartChat = m.questionType == ScriptsQuestionType.None;
                        me.bindPopupForStartingChat({
                            popupSelector: '.apexchat_prechat_message_bubble',
                            shouldStartChat
                        });
                    }
                });
            } else {
                me.autoMessageRendering({
                    message,
                    chatMsg,
                    index
                });
            }
            // checking chatroom msg is script message aur text message
        } else if (
            chatMsg.scriptAnswerId > 0 &&
            (chatMsg.questionType != ScriptsQuestionType.None || chatMsg.agentScriptDocuments) &&
            chatMsg.visitorResponseStatus == ScriptVisitorResponseStatus.UnAnswered
        ) {
            logIt(chatMsg);
            me.agentScriptAnswerId = -1;
            chatMsg.dontAppendExisitngContent = true; // we need detection here for QT is from Dashboard to handle animation.
            me.messagePopupUI.clear();
            me.messagePopupUI.render(chatMsg);
            await me.QTRendererExt.questionTypeRenderer.renderMessage(
                chatMsg,
                me.QTRendererExt.afterRenderMessage.bind2(me.QTRendererExt)
            );
            me.messagePopupUI.questionTypeUIConfiguration(chatMsg.questionType);
        } else {
            me.messagePopupUI.render(chatMsg);
        }
        setTimeout(() => {
            const input = me.DOM.getElementById(`apexchat_question_type_text_input_${preChatMsg.agentScriptAnswerId}`);
            const maxLength = 16;
            if (input) {
                // Get current placeholder
                let placeholder = input.getAttribute("placeholder") || "";

                // Truncate if it’s longer than maxLength and optionally add ellipsis
                if (placeholder.length > maxLength) {
                    placeholder = placeholder.slice(0, maxLength) + "…";
                    input.setAttribute("placeholder", placeholder);
                }
            }
        }, 50)
    }

    queueAutoMessaging() {
        const me = this;
        if (
            me.options.videoGreet.videoGreetMessages &&
            me.options.videoGreet.videoGreetMessages.length > 0
        ) {
            let lastPreChatPopoutMessage = me.getLastMessageCache();
            if (!lastPreChatPopoutMessage) {
                // It means the next message is first to be display
                lastPreChatPopoutMessage = {
                    index: 0,
                    duration: me.options.videoGreet.preChatFirstMessageTimeout
                        ? 1000 * me.options.videoGreet.preChatFirstMessageTimeout
                        : 1000
                };
            }
            // CHAT-6794 [PreChat] - Mapped Question on Page Refresh not appearing
            // summary: if mapped question has appeared, in case of refresh it should appear again instead of parent question
            const hasMappedQuestionAppeared = storageAPIExists(
                TempCache.APEXCHAT_PRECHAT_MAPPED_QUESTION_COOKIE
            );
            let lastMappedQuestion;
            if (hasMappedQuestionAppeared) {
                lastMappedQuestion = JSON.parse(
                    getStorageAPIValue(TempCache.APEXCHAT_PRECHAT_MAPPED_QUESTION_COOKIE)
                );
            }
            me.queueNextMessage(
                lastPreChatPopoutMessage.index,
                lastPreChatPopoutMessage.duration,
                lastMappedQuestion
            );
        }
    }

    queueNextMessage(index, duration, lastMappedQuestion) {
        // show next message if available
        const me = this;
        if (me.options.videoGreet.videoGreetMessages.length == index) {
            return;
        }
        if (index < 0) {
            // Do not show the next message if somebody close the message and then refresh the page
            // In message close event we are setting the index of the last message = -1
            return;
        }
        if (me.options.videoGreet.videoGreetMessages.length > index) {
            // CHAT-6794 [PreChat] - Mapped Question on Page Refresh not appearing
            // summary: Once a mapped question appears and the visitor decides to refresh the page, rather than the parent question appearing, the visitor will now see the mapped question.
            // lastMappedQuestion: Its only for Predefined messages.
            // it will be always 'NULL' in case of running Chat session,
            // It could be 'Object' only if the last prechat msg was not Parent Question.
            me.messageTimeout = window.setTimeout(() => {
                me.displayMessage(index, true, lastMappedQuestion);
            }, duration);
        }
        // summary: isPlainText is the plain text when user adds plain text from edit profile not agent scripted plain text.
        const isPlainText =
            me.options.videoGreet.videoGreetMessages[index - 1] &&
            me.options.videoGreet.videoGreetMessages[index - 1].messageType ==
            PreChatMessageType.plain_Text;
        // isAgentScript means its agent script.
        const isAgentScript =
            me.options.videoGreet.videoGreetMessages[index - 1] &&
            me.options.videoGreet.videoGreetMessages[index - 1].messageType ==
            PreChatMessageType.agent_Script;
        // isQuestionType and None means Plain Text.
        const isQTNone =
            me.options.videoGreet.videoGreetMessages[index - 1] &&
            me.options.videoGreet.videoGreetMessages[index - 1].questionType ==
            ScriptsQuestionType.None;
        // JIRA_4241 - Checking that Prechat message is Last, Plain Text and prevent multi-rendering.
        if (
            me.options.videoGreet.videoGreetMessages.length == index && // To Make sure Last PreChat Msg
            (isPlainText || (isAgentScript && isQTNone)) &&
            !me.options.videoGreet.videoGreetMessages[index - 1].isLastPreChatMessage
        ) {
            // prevent multi-rendering
            me.options.videoGreet.videoGreetMessages[index - 1].isLastPreChatMessage = true;
            me.messageTimeout = window.setTimeout(() => {
                me.displayMessage(index - 1, true);
            }, duration);
            // return;
        }
        me.setLastMessageCache(index, duration);
    }

    bindPopupForStartingChat(options) {
        const me = this;
        const { popupSelector } = options;
        const { message } = options;
        me.$(popupSelector, me.DOM).data('shouldStartChat', options.shouldStartChat);
        if (options.shouldStartChat) {
            me.$(popupSelector, me.DOM).on('click.startchat', function (e) {
                me.startChatFromVideoGreet(e, {
                    srcElement: this,
                    message
                });
            });
        } else {
            // unbind event when qt is not none
            me.$(popupSelector, me.DOM).off('click.startchat');
        }
        me.handleADA(
            me.DOM.querySelector(popupSelector),
            me.startChatFromVideoGreet.bind2(this, {
                srcElement: me.$(popupSelector, me.DOM),
                message
            })
        );
    }

    async renderScriptMessage(message) {
        const me = this;
        const messageLog = {};
        message.text = parseTemplate(removeTextFollowedByColon(message.text), me.options);
        me.agentScriptAnswerId = message.id;
        // create model for message logging
        messageLog.visitorId = me.options.visitorId;
        messageLog.text = message.text;
        messageLog.scriptAnswerId = message.id;
        messageLog.questionType = message.questionType;
        messageLog.options = message.options;
        messageLog.visitorResponseStatus = ScriptVisitorResponseStatus.UnAnswered;
        messageLog.visitorResponseType = message.visitorResponseType;
        messageLog.questionTypeDisplayListForVisitor = message.displayListForVisitor;
        messageLog.isSplitMessage = message.isSplitMessage;
        messageLog.sourceType = SourceType.VideoGreet;
        await me.logMessageOnServer(messageLog);
        if (message.questionType == ScriptsQuestionType.FullText) {
            message.userId = message.userId || 0;
            message.participantDisplayName = message.participantDisplayName || '';
            message.createdOn = new Date();
            me.QTRendererExt.questionTypeRenderer.renderMessage(
                message,
                me.QTRendererExt.afterRenderMessage.bind2(me.QTRendererExt)
            );
        }
        // check if question type is None and msg does not contain files
        // it prevent to go to QTRenderer to render message
        else if (
            message.questionType === ScriptsQuestionType.None &&
            !message.agentScriptDocuments
        ) {
            me.DOM.getElementById('apexchat_prechat_message').innerHTML = message.text;
            me.$('#apexchat_greet_video_start_trigger', me.DOM).show();
        } else {
            // render agent script message
            me.DOM.getElementById('apexchat_prechat_message').innerHTML = '';
            message.userId = message.userId || 0;
            message.participantDisplayName = message.participantDisplayName || '';
            message.createdOn = new Date();
            message.questionTypeDisplayListForVisitor = message.displayListForVisitor;
            await me.QTRendererExt.questionTypeRenderer.renderMessage(message);
            if (message.questionType == ScriptsQuestionType.None) {
                me.$('#apexchat_greet_video_start_trigger', me.DOM).show();
            }
            me.questionTypeUIConfiguration();
        }
        // here, we make sure we grab the messages which have been shown
        // while prechat is displayed/not hidden
        const m = message;
        const currentPreChatState = me.getCurrentState();
        m.isShown = currentPreChatState === WidgetStates.ShownMaximized;
        ApexChat.videoGreetMessagesDisplayed = ApexChat.videoGreetMessagesDisplayed || [];
        if (m.isShown) {
            ApexChat.videoGreetMessagesDisplayed.push(m);
        }
    }

    setAllowBackgroundClick(questionType) {
        const me = this;
        if (
            questionType >= 0 &&
            questionType !== ScriptsQuestionType.None &&
            questionType !== ScriptsQuestionType.Text &&
            questionType !== ScriptsQuestionType.Time &&
            questionType !== ScriptsQuestionType.TimeCalendar &&
            questionType !== ScriptsQuestionType.CalendarDate
        ) {
            me.allowBackgroundClick = false;
        }
    }

    questionTypeUIConfiguration(questionType) {
        const me = this;
        me.setAllowBackgroundClick(questionType);
        ADACompliant.push(me.$('.apexchat_ada_compliance', me.DOM)).apply();
        me.$('.apexchat_question_type_close_button', me.DOM).attr(
            'style',
            'display:none !important'
        );
        me.$('#apexchat_click_instruction', me.DOM).attr('style', 'display: none !important');
        me.$('#apexchat_participant_display_name', me.DOM).attr(
            'style',
            'display: none !important'
        );
        me.$('#apexchat_participant_display_col', me.DOM).attr('style', 'display: none !important');
    }

    async logMessageOnServer(log) {
        const me = this;
        if (localstorageAPIExists('livechat_prechat_msg_array')) {
            me.messageArray = JSON.parse(localStorageAPIGet('livechat_prechat_msg_array'));
        }
        if (log.isSplitMessage) {
            // if message is splitted message then we dont need to log on server because we already did it
            return;
        }
        const videoGreetMsgObj = me.getDuplicatedObjectFromArray(me.messageArray, log.text, 'text');

        if (videoGreetMsgObj) {
            me.videoGreetMessageId = videoGreetMsgObj.id;
            return; // duplicated message.
        }
        const url = `${GlobalVariables.ApexChatBaseUrl}api/prechat/messages`;
        // encode just in case there are any HTML tags to avoid request failure due to CSRF
        const encodedLog = encodeHTML(JSON.stringify(log));

        const response = await fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            method: "POST",
            body: encodedLog
        })
        const res = await response.json();

        me.videoGreetMessageId = res.id;
        me.messageArray.push({ id: me.videoGreetMessageId, text: log.text });

        ApexChat.localStorageAPI.Store(
            'livechat_prechat_msg_array',
            JSON.stringify(me.messageArray)
        );

        me.setVideoGreetMessageIdsCache(me.videoGreetMessageId);
    }

    getDuplicatedObjectFromArray(array, msg, property) {
        let i = array.length;
        while (i--) {
            if (array[i][property] === msg) {
                return array[i];
            }
        }
        return null;
    }

    setLastMessageCache(index, duration) {
        const me = this;
        const message = { index, duration };
        Cookies.set(me.lastMessageStoreName, JSON.stringify(message));
    }

    getLastMessageCache() {
        const me = this;
        const message = Cookies.get(me.lastMessageStoreName);
        return message ? JSON.parse(message) : null;
    }

    getMessageCounterCache() {
        const me = this;
        const counter = Cookies.get(me.messageCounterStoreName) || 0;
        return parseInt(counter);
    }

    setVideoGreetMessageIdsCache(id) {
        // store pre chat message data in local storage
        const storeData = getCookieValue(TempCache.APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE);
        if (storeData) {
            var storeJson = JSON.parse(storeData);
        }
        if (!storeJson) {
            storeJson = [];
        }
        storeJson.push(id);
        Cookies.set(TempCache.APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE, stringify(storeJson));
    }

    show() {
        super.show();
        this.maximize();
    }

    displayLastMessageFromHistory() {
        const me = this;
        const lastMessage = ApexChat.TryParse(Cookies.get('livechat_chat_lastmessage')); // get last message of chat from cookies
        if (
            lastMessage &&
            lastMessage.questionType !== ScriptsQuestionType.None &&
            (!me.lastMessageDisplayed ||
                (me.lastMessageDisplayed && me.lastMessageDisplayed.id != lastMessage.id))
        ) {
            // check if message is question type and message is not appear before so show it
            if (lastMessage.text.indexOf('||') > -1) {
                // we are not handling pipe message here, as this is perfectly render by onMessageArrived
                return;
            }
            if (lastMessage.options) {
                lastMessage.options = addOptionProperty(lastMessage.options);
            }
            me.lastMessageDisplayed = lastMessage;
            window.setTimeout(() => {
                me.displayMessage(0, false, lastMessage);
            }, lastMessage.questionTypeDelaySeconds * 1000);
        }
    }

    hide() {
        super.hide();
        // resize iframe
        this.postMessage(
            {
                event: WidgetTypes.VideoGreetInvitation + WidgetStates.Hidden,
                data: {}
            },
            '*'
        );
        window.clearTimeout(this.messageTimeout);
        this.pipeMessageHandler.reset(); // stop all processing of pipe messages if its running
        document.body.classList.remove('apexchat-video-greet-maximized-body');
        // remove debounced resize handler for realtime window height changed
        if (typeof this.windowHeightOnResize === 'function') {
            window.removeEventListener('resize', this.windowHeightOnResize);
        }
    }

    maximize() {
        super.maximize();
    }

    generateVideoGreet() {
        const me = this;
        const iframeEl = document.getElementById('apexchat_video_greet_invitation_frame');
        me.$(me.$(me.options.videoGreetMuteTrigger, me.DOM))
            .find('img').attr('src', 'https://d3b4i635mede5k.cloudfront.net/' + (me.options.videoGreet.soundEnabled ? 'unmute' : 'mute') + '.png');
        const isMaximized = me.isVideoGreetStateMaximized();
        if (isMaximized) {
            me.maximizeVideoGreet();
            me.$(me.options.videoGreetPlayPauseIcon, me.DOM).toggleClass('play_icon pause_icon');
            me.videoPlayerState = 'paused';
            if (me.isPageRefreshed()) {
                me.videoPlayer.pause();
                me.handleVideoGreetMute();
                me.togglePlayIcon();
            }
            me.$(me.options.videoGreetInvitationOverlayTrigger, me.DOM).hide();
            me.$(me.options.videoGreetLoader, me.DOM).hide();
            if (!me.isChatInProgress()) {
                // ref. CHAT-4589: we should stop pre-chat message popups on susequent page reloads
                me.queueAutoMessaging();
            } else {
                me.startChatFromVideoGreet();
            }
        }
        if (me.options.videoGreet.greetText) {
            me.$(this.options.videoGreetTooltip, me.DOM)
                .children(this.options.videoGreetTooltipText)
                .text(me.options.videoGreet.greetText);
        } else {
            me.$(this.options.videoGreetTooltip, me.DOM).hide();
        }
        if (me.isMobile()) {
            const container = me.$('#apexchat_video_greet_invitation_max', me.DOM);
            container.addClass('apexchat_video_greet_invitation_mobile');
        }
        if (me.videoPlayer) {
            me.videoPlayer.on('ready', () => {
                if (me.options.videoGreet.animatedImageUrl) {
                    me.postMessage({
                        event: 'videogreet-gif-file-loaded',
                        data: {
                            imageUrl: me.options.videoGreet.animatedImageUrl
                        }
                    });
                }

                Promise.all([me.videoPlayer.height(), me.videoPlayer.width()]).then(
                    (dimensions) => {
                        const width = dimensions[0];
                        const height = dimensions[1];
                        if (width > height) {
                            me.$(me.options.videoGreetInvitationContainer, me.DOM).addClass(
                                'video_greet_landscape_video'
                            );
                        }
                    }
                );

                if (!me.videoPlayerState) {
                    me.videoPlayerState = 'playing';
                }

                me.$(me.options.videoGreetPlayTrigger, me.DOM).on('click', () => {
                    me.handlePlayPause();
                });

                me.$(me.options.videoGreetMuteTrigger, me.DOM).on('click', () => {
                    me.handleVideoGreetMute();
                });

                me.$('#apexchat_greet_video_start_trigger', me.DOM).on('click', () => {
                    me.videoPlayer.pause();
                    me.videoPlayer.currentTime(0);
                    me.startChatFromVideoGreet();
                });

                let playedInitially = false;
                me.videoPlayer.on('play', () => {
                    if (!playedInitially) {
                        me.show();
                        setTimeout(() => {
                            me.$(me.options.prechatMessagesContainer, me.DOM).css({
                                visibility: 'visible',
                                opacity: 1
                            });
                            me.$(me.options.videoGreetTooltip, me.DOM).addClass(
                                'video_greet_slide_text'
                            );
                            if (
                                me.$(me.options.videoGreetTooltip, me.DOM).text() &&
                                me.$(me.options.videoGreetTooltip, me.DOM).text().length > 34
                            ) {
                                me.$(me.options.videoGreetTooltip, me.DOM).addClass(
                                    'video_greet_slide_text_smaller'
                                );
                            }
                            me.$(me.options.videoGreetControls, me.DOM).addClass(
                                'apexchat_greet_video_controls_show'
                            );
                            if (!isMaximized) {
                                if (!me.isChatInProgress()) {
                                    // ref. CHAT-4589: we should stop pre-chat message popups on susequent page reloads
                                    me.queueAutoMessaging();
                                }
                            }
                        });
                    }
                    logIt('▶ Video Greet:: played!');
                    playedInitially = true;
                });

                me.videoPlayer.on('timeupdate', function (data) {
                    if (
                        this.currentTime() > 0 &&
                        me.$(me.options.videoGreetLoader, me.DOM).is(':visible')
                    ) {
                        me.$(me.options.videoGreetLoader, me.DOM).fadeOut();
                    }
                    if (this.currentTime()) {
                        logIt(
                            `▶ Video Greet:: in progress! ${this.currentTime().toFixed(
                                2
                            )} seconds watched`
                        );
                        ApexChat.options.videoGreetWatchTime = this.currentTime().toFixed(2);
                    }

                    me.resetPlayerAfterVideoEnded(data);
                });

                me.$(me.options.videoGreetCloseTrigger, me.DOM).on('click', () => {
                    me.minimizeVideoGreet();
                    me.handlePrechatVisiblity(true);
                });

                const h = iframeEl.clientHeight - 10;
                const w = iframeEl.clientWidth;
                me.videoGreetDimenstionRatio = w / h;

                me.$(me.options.videoGreetInvitationOverlayTrigger, me.DOM).on(
                    'click',
                    function () {
                        me.$(me.options.videoGreetControls, me.DOM)
                            .removeClass('apexchat_greet_video_controls_show')
                            .delay()
                            .queue(function (next) {
                                me.$(this).addClass('apexchat_greet_video_controls_show');
                                next();
                            });
                        me.maximizeVideoGreet();
                        setTimeout(() => {
                            me.$(me.options.videoGreetPlayTrigger, me.DOM)
                                .find(me.options.videoGreetPlayPauseIcon)
                                .toggleClass('play_icon pause_icon');
                            me.replaceMuteIcon(false);
                        });
                        me.onWindowResize(me.videoGreetDimenstionRatio);
                        me.$(this).hide();
                    }
                );

                if (me.isVideoGreetStateMaximized()) {
                    me.resetPlayerAndPlay();
                }

                me.videoPlayer.on('ended', () => {
                    me.onVideoEnded();
                });

                me.$(window).resize(() => {
                    me.onWindowResize(me.videoGreetDimenstionRatio);
                });
                me.handlePrechatVisiblity();
            });
        }
    }

    resetPlayerAfterVideoEnded(data) {
        const me = this;
        if (me.videoPlayer.muted()) {
            // hack to reset the vimeo player in case of
            // hiding free account video suggestion
            // checking if the duration of the video is about to end
            // then reset the player, the video will end 100 ms before of it's actual time

            if (data.duration - data.seconds <= 0.3) {
                me.videoPlayer.currentTime(0);
            }
            if (data.duration - data.seconds <= 0.3) {
                setTimeout(() => {
                    me.videoPlayer.currentTime(0);
                    me.triggerPauseIfPlaying();
                    me.videoPlayerState = 'paused';
                    me.togglePlayIcon();
                    me.$(me.options.videoGreetSeekbar, me.DOM).css('width', 0);
                }, 200);
            }
        }
    }

    onWindowResize(ratio) {
        const me = this;
        const winHeight = window.innerHeight;
        const isMaximized = me.isVideoGreetStateMaximized();
        const widgetInitialHeight = isMaximized
            ? ApexChat.WidgetMaximizedHeight
            : ApexChat.WidgetMinimizedHeight;
        const widgetInitialWidth = isMaximized
            ? ApexChat.WidgetMaximizedWidth
            : ApexChat.WidgetMinimizedWidth;
        let newHeight = widgetInitialHeight;
        const newWidth = widgetInitialWidth;
        if (winHeight < widgetInitialHeight) {
            newHeight = winHeight - 20;
            // if keep the ration on maximizing
            // newWidth = ratio * winHeight;
        }
        if (!me.isMobile()) {
            me.postMessage({
                event: 'videogreet-size',
                data: {
                    width: newWidth,
                    height: newHeight,
                    isPreChatRoundedTheme: me.options.isPreChatRoundedTheme
                }
            });
        }
        logIt('▶ Video Greet:: window resized');
    }

    onVideoEnded() {
        const me = this;
        me.videoPlayerState = 'paused';
        me.togglePlayIcon();
        me.$(me.options.videoGreetSeekbar, me.DOM).css('width', 0);
        logIt('▶ Video Greet:: video ended!');
    }

    handlePlayPause() {
        const me = this;
        me.$(me.options.videoGreetPlayTrigger, me.DOM)
            .find(me.options.videoGreetPlayPauseIcon)
            .toggleClass('play_icon pause_icon');
        if (me.videoPlayerState === 'playing') {
            me.videoPlayerState = 'paused';
            me.videoPlayer.pause();
            logIt('▶ Video Greet:: paused');
        } else {
            me.videoPlayerState = 'playing';
            me.videoPlayer.play();
            logIt('▶ Video Greet:: resumed');
        }
    }

    handleVideoGreetMute() {
        const me = this;
        if (me.videoPlayer) {
            console.log(`video is on mute:${me.videoPlayer.muted()}`);
            if (me.videoPlayer.muted()) {
                // If the video is muted, unmute it
                me.videoPlayer.muted(false);
                me.replaceMuteIcon(false);
            } else {
                // If the video is not muted, mute it
                me.videoPlayer.muted(true);
                me.replaceMuteIcon(true);
            }
        }
    }

    replaceMuteIcon(muted) {
        const me = this;
        me.$(me.$(me.options.videoGreetMuteTrigger, me.DOM))
            .find('img')
            .attr('src', `https://d3b4i635mede5k.cloudfront.net/${muted ? 'mute' : 'unmute'}.png`);
        logIt(`▶ Video Greet:: icon changed to ${muted}` ? 'mute' : 'unmute');
    }

    handlePrechatVisiblity(show = false) {
        var me = this;
        me.postMessage({
            event: WidgetTypes.VideoGreetInvitation + WidgetStates.Refreshed,
            data: { show }
        });
    }
    maximizeVideoGreet() {
        const me = this;
        me.$(this.options.videoGreetTooltip, me.DOM).hide();
        me.setVideoGreetStateMaximized('true');
        if (me.videoPlayer) {
            me.resetPlayerAndPlay();
        }
        me.$(me.options.videoGreetInvitationContainer, me.DOM).toggleClass(
            me.options.togglePlayerClassess
        );
        me.options.wiggleEnabled = false;
        clearTimeout(ApexChat.wigglingTimeouts);
        // full screen on mobile
        if (me.isMobile()) {
            const container = me.$('#apexchat_video_greet_invitation_max', me.DOM);
            container.addClass('apexchat_video_greet_invitation_mobile_maximized');
            const outerWrpper = me.$('#apexchat_video_greet_invitation_wrapper');
            outerWrpper.css({
                margin: 0,
                padding: 0,
                left: 0
            });
            outerWrpper.addClass('apexchat_video_greet_invitation_wrapper_mobile_maximized');
            if (!me.resizeBound) {
                me.resizeBound = true;
                // update resize handler for realtime window height change
                me.windowHeightOnResize = debounce(() => {
                    me.windowHeight = window.innerHeight;
                }, 300);

                window.addEventListener('resize', me.windowHeightOnResize);
            }
            me.postMessage({
                event: 'videogreet-size',
                data: {
                    width: window.innerWidth,
                    height: me.windowHeight,
                    isPreChatRoundedTheme: me.options.isPreChatRoundedTheme,
                    isMobile: true,
                    maximize: true, // flag for fullscreen
                }
            });
        } else {
            me.postMessage({
                event: 'videogreet-size',
                data: {
                    width: ApexChat.WidgetMaximizedWidth,
                    height: ApexChat.WidgetMaximizedHeight,
                    onCreateSizing: true,
                    addValue: me.templateRenderer.heightPosition,
                    isPreChatRoundedTheme: me.options.isPreChatRoundedTheme
                }
            });
        }
        logIt('▶ Video Greet:: maximized');
    }

    isMobile() {
        return this.options.isMobile || Browser.isiOS() || Browser.isAndroid();
    }

    resetVideoGreetVideo() {
        const me = this;
        ApexChat.logIt('▶ Video Greet:: reset');
        if (me.videoPlayer) {
            me.videoPlayer.pause();
            me.videoPlayer.currentTime(0);
            // me.minimizeVideoGreet(true);
            me.$(me.options.videoGreetPlayPauseIcon, me.DOM).toggleClass('play_icon pause_icon');
            me.videoPlayerState = 'paused';
            ApexChat.Vimeo = null;
        }
    }

    resetPlayerAndPlay() {
        const me = this;
        me.videoPlayer.currentTime(0);
        me.triggerPlayIfPaused();
        me.videoPlayer.on('timeupdate', function (data) {
            if (this.currentTime()) {
                const currentTime = this.currentTime();
                const duration = this.duration();
                // Calculate the percentage of playtime
                const playtimePercentage = (currentTime / duration) * 100;
                logIt(`▶ Video Greet:: progress ${playtimePercentage}%`);
                me.$(me.options.videoGreetSeekbar, me.DOM).css('width', `${playtimePercentage}%`);
            }
        });
        me.videoPlayer.currentTime(0);
        me.videoPlayer.loop(false);
        me.videoPlayer.muted(false);
    }

    minimizeVideoGreet(isPaused) {
        const me = this;
        me.videoPlayer.muted(true);
        me.triggerPauseIfPlaying();
        me.state.changeState({
            origin: WidgetTypes.VideoGreetInvitation,
            toState: WidgetStates.Closed
        });
        logIt('▶ Video Greet:: closed');
    }

    triggerPlayIfPaused() {
        const me = this;
        if (me.videoPlayer.paused()) {
            me.videoPlayer.play();
        }
    }

    triggerPauseIfPlaying() {
        const me = this;
        if (me.videoPlayer.paused()) {
            me.videoPlayer.pause();
        }
    }

    togglePlayIcon() {
        const me = this;
        me.$(me.options.videoGreetPlayTrigger, me.DOM)
            .find(me.options.videoGreetPlayPauseIcon)
            .addClass('play_icon')
            .removeClass('pause_icon');
    }

    togglePauseIcon() {
        const me = this;
        me.$(me.options.videoGreetPlayTrigger, me.DOM)
            .find(me.options.videoGreetPlayPauseIcon)
            .addClass('pause_icon')
            .removeClass('play_icon');
    }

    setVideoGreetStateMaximized(status) {
        Cookies.set(this.options.isVideoGreetMaximized, status);
    }

    isVideoGreetStateMaximized() {
        return Cookies.get(this.options.isVideoGreetMaximized) === 'true';
    }

    isVideoGreetStateSmall() {
        return Cookies.get(this.options.isVideoGreetMaximized) === 'small';
    }
}
